class Settings {

    public URL = {
        api: process.env.VUE_APP_HOST_API,
        static: process.env.VUE_APP_HOST_STATIC,
    };

    public tokenCSRF: string = '';

}

export const settings: Settings = new Settings();